if (!customElements.get('mojokoe-creator-film')) {
  customElements.define('mojokoe-creator-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.errorMessage = this.querySelector('[data-film-error]');
      this.fallbackLink = this.querySelector('[data-film-fallback]');
      this.playButton = this.querySelector('[data-film-play]');
      const options = { signal: this.controller.signal };
      // Reset browser caption preferences once, not on each Play or Pause.
      // After the first metadata load, native controls own the user's choice.
      if (!this.captionsInitialized) this.disableInitialCaptions();
      this.video.addEventListener('loadedmetadata', () => {
        if (this.captionsInitialized) return;
        this.disableInitialCaptions();
        this.captionsInitialized = true;
      }, options);
      this.selectSource();
      this.video.addEventListener('play', () => {
        this.hasPlayed = true;
        this.video.controls = true;
        if (this.playButton) this.playButton.hidden = true;
      }, options);
      this.video.addEventListener('playing', () => {
        if (this.errorMessage) this.errorMessage.hidden = true;
      }, options);
      this.video.addEventListener('error', () => {
        if (this.errorMessage) this.errorMessage.hidden = false;
      }, options);
      this.mediaQuery.addEventListener('change', () => this.selectSource(), options);
      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.activate(), options);
        const initial = !this.activationRequested && !this.hasPlayed && this.video.paused && this.video.currentTime === 0 && this.video.played.length === 0;
        this.video.controls = !initial;
        this.playButton.hidden = !initial;
      }
    }

    activate() {
      if (this.activationRequested) return;
      this.activationRequested = true;
      if (this.playButton) this.playButton.hidden = true;
      this.video.controls = true;
      this.video.focus();
      const controller = this.controller;
      const failed = () => {
        if (this.controller !== controller) return;
        if (this.errorMessage) this.errorMessage.hidden = false;
      };
      try {
        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(failed);
      } catch {
        failed();
      }
    }

    disableInitialCaptions() {
      for (const track of this.video.textTracks) {
        if (track.kind === 'captions' || track.kind === 'subtitles') track.mode = 'disabled';
      }
    }

    selectSource() {
      if (this.hasPlayed || !this.video.paused || this.video.currentTime > 0 || this.video.played.length > 0) return;
      const mobile = Boolean(this.mediaQuery.matches && this.dataset.mobileSrc);
      const source = mobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (!source) return;
      this.dataset.format = mobile ? 'mobile' : 'desktop';
      const poster = mobile
        ? this.dataset.mobilePoster || this.dataset.desktopPoster
        : this.dataset.desktopPoster;
      if (poster && this.video.getAttribute('poster') !== poster) this.video.poster = poster;
      if (!poster) this.video.removeAttribute('poster');
      if (this.video.getAttribute('src') !== source) {
        this.video.src = source;
        if (this.errorMessage) this.errorMessage.hidden = true;
      }
      if (this.fallbackLink) this.fallbackLink.href = source;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
